import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, SectionBadge } from "./Shared";
import { FAQS } from "../data";

export default function Faq() {
  return (
    <section id="faq" className="py-24 md:py-32">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-16 px-6 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionBadge>07 — FAQ</SectionBadge>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-serif text-5xl font-medium leading-[0.95] tracking-tighter text-ink md:text-6xl">
              Good <span className="italic text-leaf">questions</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xs text-base font-light leading-relaxed text-leaf/80">
              Everything you need to know before your first sip. Still curious?
              Give us a call — we love to talk juice.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.15}>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-leaf/15">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-7 text-left font-serif text-2xl font-medium tracking-tight text-ink transition-colors duration-300 hover:no-underline data-[state=open]:text-melon md:text-3xl"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="pb-7 text-base font-light leading-relaxed text-leaf/80"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
